document.addEventListener('DOMContentLoaded', function () {
    var splideMountPoint = document.querySelector('.block-coworkers');
    if (!splideMountPoint) {
        return;
    }

    var splide = new Splide('.block-coworkers', {
        perPage: 4,
        perMove: 1,
        autoWidth: false,
        gap: 32,
        arrows: true,
        padding: { right: 48 },
        breakpoints: {
            1024: {
                perPage: 3,
            },
            767: {
                perPage: 2,
            },
            640: {
                perPage: 1,
                padding: { right: 80 },
                gap: 15,
            },
        }
    });

    splide.mount();
});